import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; 

import App from './App';
import './App.scss';
import ScrollToTop from './ScrollToTop';
 
window.onerror = function (message, source, lineno, colno, error) {
  console.log("Global Error Caught:", message, source, lineno, colno, error);
  return true;  
};

window.addEventListener("unhandledrejection", (event) => {
  console.log("Unhandled Promise Rejection:", event.reason);
  if (event.preventDefault) {
    event.preventDefault();  
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <React.Fragment> 
      <BrowserRouter>
        <ScrollToTop />
        <App />
      </BrowserRouter> 
    </React.Fragment>
  </StrictMode>
);
